import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { restoreWorkspaceFolders } from '../../../api/workspaces/folders/restoreWorkspaceFolders';

export function useRestoreWorkspaceFolder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: restoreWorkspaceFolders,
    onSettled: (_data, _error, { workspaceId }) => {
      return Promise.all([
        queryClient.invalidateQueries(workspaceKeys.allFolders(workspaceId)),
        queryClient.invalidateQueries(workspaceKeys.list()),
      ]);
    },
  });
}
